import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { PontosCriticosTipos } from "../models/pontos-criticos-tipos.model";

@Injectable()
export class PontosCriticosTiposService extends BaseService<PontosCriticosTipos>{

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/pontos-criticos-tipos';
  }

}